// @flow
import React from 'react';
import { FieldArray, getIn, useFormikContext } from 'formik';
import { COMMITTED_CAPACITY } from '@streaming-projects/user-commit-details/committed-capacity/enums';
import { SPCommittedCapacityDimensionsSingleRow } from '@streaming-projects/user-commit-details/committed-capacity/SPCommittedCapacityDimensionsSingleRow';
import { If } from '@presentational/If';
import { DimensionHeadersContainer } from '@streaming-projects/user-commit-details/committed-capacity/dimensions/DimensionHeadersContainer';

export const SPCommittedCapacityDimensionsGrid = ({
  metricIndex,
  metricDimensionRefs,
  metricRow,
  metricArrayHelpers,
}) => {
  const { values: formikValues } = useFormikContext();
  const dimensionsPath = `${COMMITTED_CAPACITY.METRICS_LEVEL_CONFIGURATION_ARRAY}[${metricIndex}]["${COMMITTED_CAPACITY.METRICS_DIMENSIONS_LEVEL_CONFIGURATION_ARRAY}"]`;
  const configuredDimensionRows = getIn(formikValues, dimensionsPath) ?? [];

  return (
    <FieldArray
      name={dimensionsPath}
      render={(arrayHelpers) => {
        const metricName = metricRow.metricName;
        metricDimensionRefs.current.dimensionArrayHelpersMap[metricName] = arrayHelpers;
        return (
          <>
            <If test={configuredDimensionRows.length > 0}>
              <DimensionHeadersContainer metricName={metricName} />
            </If>
            {configuredDimensionRows.map((row, index) => {
              return (
                <SPCommittedCapacityDimensionsSingleRow
                  dimensionArrayHelpers={arrayHelpers}
                  dimensionIndex={index}
                  key={`${index}${row.id}`}
                  metricArrayHelpers={metricArrayHelpers}
                  metricIndex={metricIndex}
                  metricRow={metricRow}
                  row={row}
                />
              );
            })}
          </>
        );
      }}
    />
  );
};
